<template>
  <div id="sku">
    <div class="groupedSaleAttrs">
      <div v-for="(ulItem, ulIndex) in groupedSaleAttrs" :key="ulIndex" class="ulItem">
        <div class="name" :style="ulItemStyle">{{ ulItem.name }}</div>
        <ul class="liItemBox">
          <li
            :class="liItem.thumbnail ? 'liColorItem' : ['liItem', ulItem.id === liItem.id ? 'active' : '']"
            :style="[
              liItem.thumbnail
                ? {
                    marginBottom: '35px'
                  }
                : {
                    color: liItem.screen ? '' : '#ccc',
                    border: liItem.screen ? '1px solid #999' : '1px solid #e3e3e3',
                    marginBottom: '35px'
                  },
              skuStyle
            ]"
            v-for="(liItem, liIndex) in ulItem.list"
            :key="liIndex"
            @click="changeListActive(ulItem, liItem, liItem.screen)"
          >
            <div
              v-if="liItem.thumbnail"
              :class="['icon', ulItem.id === liItem.id ? 'active' : '']"
              :style="[
                {
                  color: liItem.screen ? '' : '#ccc',
                  backgroundColor: liItem.thumbnail,
                  border: '1px solid',
                  borderColor: liItem.screen ? '#D0D0D0' : ''
                }
              ]"
            ></div>
            <div class="text" v-if="liItem.thumbnail">{{ liItem.id }}</div>
            <div v-if="!liItem.thumbnail">{{ liItem.id }}</div>
          </li>
        </ul>
      </div>
      <slot name="moreList" />
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
export default {
  name: 'sku',
  data() {
    return {
      groupedSaleAttrsInit: [],
      groupedSaleAttrs: [],
      skuIDList: [],
      skuItem: {
        name: '',
        text: '',
        src: '',
        price: 0
      }
    }
  },
  watch: {
    groupedSaleAttrs(to, form) {
      this.matchingFun(to)
    },
    /**
     *  handler: function(to) {
        if (to && to.data) {
          this.setDataforSKU(to)
     */
    skuData: {
      handler: function(newValue, oldValue) {
        if (!_.isEqual(newValue, oldValue)) {
          if (Object.keys(newValue).length > 0) {
            this.setDataforSKU(newValue)
          }
        }
      },
      deep: true,
      immediate: true
    },
    selectList(val) {
      this.setDataforSKU(this.skuData, val)
    }
  },
  props: {
    skuData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    callback: {
      type: Function,
      default: () => {}
    },
    selectList: {
      type: Array,
      default: () => []
    },
    skuStyle: {
      type: Object,
      default: () => {
        return {}
      }
    },
    ulItemStyle: {
      type: Object,
      default: () => {
        return {}
      }
    },
    // 为了区分一个页面多个sku
    itemId: {
      type: String,
      default: '-1'
    }
  },
  mounted() {
    if (this.groupedSaleAttrs.length + this.skuIDList.length > 0) {
      this.matchingFun(this.groupedSaleAttrs)
    }
  },
  created() {
    // this.setDataforSKU(this.skuData)
  },
  methods: {
    // 处理销售属性和sku数据
    setDataforSKU(val, selectList) {
      const {
        data: { groupedSaleAttrs = [], skus = [] }
      } = val
      let attrVals = {}
      // 商品初始选项
      this.groupedSaleAttrsInit =
        (groupedSaleAttrs &&
          groupedSaleAttrs.map((itemGroutp) => {
            const name = itemGroutp.attrKey || ''
            // const color = itemGroutp.color || ''
            const list =
              (itemGroutp.attrVal &&
                itemGroutp.attrVal.map((itemAttr) => {
                  itemAttr.screen = true
                  return {
                    id: itemAttr.attrVal || '',
                    name: itemAttr.attrKey || '',
                    thumbnail: itemAttr.thumbnail || '',
                    screen: itemAttr.screen
                  }
                })) ||
              []
            let cache = selectList && selectList.filter((item) => item.name === name)[0]
            attrVals[name] = cache ? cache.id : list.length > 0 ? list[0].id : 0
            return {
              id: null,
              // color,
              name,
              list
            }
          })) ||
        this.groupedSaleAttrsInit
      // 组成SKU选择列表，用以匹配
      this.skuIDList = skus.map((skuItem) => {
        const item = Object.assign({}, skuItem) || {}
        delete item.saleAttributes
        const { saleAttributes = [] } = skuItem
        return {
          item: item,
          idList: saleAttributes
            ? saleAttributes.map((item) => ({
                id: item.attrVal || '',
                name: item.attrKey || ''
              }))
            : []
        }
      })
      // 只保留有库存的sku
      const defaultSku = this.skuIDList.filter((res) => (res.item.stockQuantity || res.item.skuQuantity) > 0)
      // 保留选中的sku到attrVals变量中
      if (defaultSku.length) {
        // 如果已经有选中的销售属性，则保存选中的销售属性
        if (val.skuIdOfMain && val.skuIdOfMain !== '') {
          defaultSku.map((res) => {
            // 找到选中的sku
            if (val.skuIdOfMain === res.item.skuId + '') {
              res.idList.forEach((item) => {
                attrVals[item.name] = item.id
              })
            }
          })
        } else {
          // 选中第一组sku
          let firstSku = []
          firstSku.push(defaultSku[0])
          firstSku.map((res) => {
            res.idList.forEach((item) => {
               attrVals[item.name] = item.id
            })
          })
        }
      } else {
        attrVals = {}
      }
      this.dealGroupedSaleAttrs(attrVals)
    },
    // 获取选中sku   ulItem-销售属性   liItem -当前点击的值
    changeListActive(ulItem, liItem, screen) {
      if (this.skuData.data.choice) {
        return
      }
      if (screen === false) {
        return
      }
      let val = liItem.id
      if (ulItem.id === liItem.id) {
        val = null
      }
      const attrVals = {}
      this.groupedSaleAttrs &&
        this.groupedSaleAttrs.map((item, i) => {
          // 如果当前遍历的属性刚好是我点击选择的属性，此时直接获得liItem的id
          // 如果不是，则直接获得当前遍历节点的id(因为在每个节点上都会挂载当前选中的属性！！！)
          attrVals[item.name] = item.name === ulItem.name ? val : item.id
        })
      this.dealGroupedSaleAttrs(attrVals)
    },
    /**
     * to-销售属性==to的id是当前选中的属性
     */
    matchingFun(to = []) {
      if (to.length === 0) {
        const { item } = this.skuIDList[0]
        let price = this.skuItem.price
        const { extraPrice } = item
        if (extraPrice) {
          const {
            extraPrice: { activityPrice }
          } = item
          price = activityPrice
        } else {
          price = item.price || this.skuItem.price
        }
        this.callback(Object.assign({}, item), this.itemId)
        this.skuItem = Object.assign({}, item, {
          name: item.name || this.skuItem.name,
          text: item.text || this.skuItem.text,
          src: item.src || this.skuItem.src,
          price
        })
        return ''
      }
      // 匹配SKU状态，为空表示无此SKU
      let selectList = []
      // 遍历sku，找到我们选择的sku
      this.skuIDList.map((IDItem) => {
        const { idList = [], item } = IDItem
        let num = 0
        // 找到我们选择的sku,(我们把选择的值挂在销售属性上)

        idList.map((idItem) => {
          to.map((toItem) => {
            if (String(idItem.name) === String(toItem.name) && String(idItem.id) === String(toItem.id)) {
              num++
            }
          })
          // sku的属性数目  和  销售属性个数  相同才是有效的sku
          if (Number(num) === to.length) {
            const { extraPrice } = item
            let price = this.skuItem.price
            // 这里是取原价
            let nativePrice = (extraPrice && extraPrice.skuPrice) || item.skuPrice
            if (extraPrice) {
              const {
                extraPrice: { activityPrice }
              } = item
              price = activityPrice
            } else {
              price = item.price || this.skuItem.price
            }
            item.nativePrice = nativePrice || price
            selectList.push(item)
            // 对外暴露的选中的sku
            this.callback(Object.assign({}, item), idList, this.itemId)
            this.skuItem = Object.assign({}, item, {
              name: item.name || this.skuItem.name,
              text: item.text || this.skuItem.text,
              src: item.src || this.skuItem.src,
              price
            })
          }
        })
      })
      if (selectList.length === 0) {
        this.callback({}, [])
      }
    },
    /**
     * 方法逻辑：
     *
     */
    filterSku(groupedSaleAttrs, attrVals) {
      // 所有sku进行过滤
      const canChooseKus = this.skuIDList.filter((sku) => {
        let n = 0
        sku.idList.map((id) => {
          groupedSaleAttrs &&
            groupedSaleAttrs.map((attr) => {
              if (id.name === attr.name && (!attrVals[attr.name] || id.id === attrVals[attr.name])) {
                n++
              }
            })
        })
        /**
         * {
            id:null
            name:精品车型
            list:[
                { id: "车型1"
                  name: "精品车型"
                  screen: true
                  thumbnail: ""}
            ]
         }
         */
        if (n === groupedSaleAttrs.length) {
          return true
        }
        return false
      })
      return canChooseKus
    },
    /**
     *当前方法作用：遍历处理每一个销售属性下的每一个可选项是否可选
     第一步：过滤出可选的sku（先不管当前遍历的销售属性，在非当前遍历的属性中去找可以操作的sku）【filterSku方法干的活】
     第二步：在上一步过滤的sku中，把属于当前销售属性的值都存起来attrValList
     第三步：遍历判断当前属性的每一个可选项是否在上面的attrValList中
     * attrVals-存放的是最后一组sku中的销售属性
     */
    dealGroupedSaleAttrs(attrVals) {
      // this.groupedSaleAttrsInit这个是销售属性数据结构是一个数组，结构如下：
      /**
         [{
            id:null
            name:精品动力
            list:[
                { id: "1.2"
                  name: "精品动力"
                  screen: true
                  thumbnail: ""}
            ]
         },
         {
            id:null
            name:精品车型
            list:[
              { id: "车型1"
                  name: "精品车型"
                  screen: true
                  thumbnail: ""}
            ]
         }
         ]
       */
      // 遍历处理销售属性
      this.groupedSaleAttrs = this.groupedSaleAttrsInit.map((attr, i) => {
        const canChooseKus = this.filterSku(
          this.groupedSaleAttrsInit.slice(0, i).concat(this.groupedSaleAttrsInit.slice(i + 1)),
          attrVals
        )
        // 在所有的可选sku列表中遍历，把当前销售属性的具体值存到attrValList中
        // 如：当前遍历的属性是精品动力，此时就遍历所有的sku,将sku中精品动力的具体值存到attrValList
        let attrValList = []
        canChooseKus.map((sku) => {
          sku.idList.map((id) => {
            if (id.name === attr.name && (sku.item.stockQuantity || sku.item.skuQuantity)) {
              attrValList.push(id.id)
            }
          })
        })
        /**
         * 只有销售属性在sku中才能点击
         * attr.list-销售属性可选值：
         * 这里是所有销售属性
         * 【动力（动力1、动力2），车型（车型1、车型2）】
         * 当前遍历的销售属性可选项[（动力1、动力2）]
         * attrValList-所有sku中，对应上面销售属性的具体值：
         * 这是所有的sku
         * 【
         *     sku1：动力=动力1，车型=车型1；
         *     sku2：动力=动力1，车型=车型2；
         *     sku3：动力=动力2，车型=车型1；
         *     sku4：动力=动力2，车型=车型2；
         *  】
         * 这里是attrValList的值：
         * [动力1，动力2]
         */
        // 对当前销售属性可选择进行遍历，来控制按钮是否可以点击
        attr.list.forEach((itemAttr) => {
          if (attrValList.indexOf(itemAttr.id) > -1) {
            itemAttr.screen = true
          } else {
            itemAttr.screen = false
          }
        })
        return {
          ...attr,
          id: attrVals[attr.name]
          // list: canChooseAttr
        }
      })
    }
  }
}
</script>

<style lang="scss">
#sku {
  margin-top: 28px;
  width: 100%;
  .groupedSaleAttrs {
    .ulItem {
      display: flex;
      align-items: center;
      /*padding-top: 15px;*/
      /*border-bottom: 1px solid #D6D6D6;*/
      align-items: flex-start;
      .name {
        display: inline-block;
        color: #333333;
        font-size: 16px;
        line-height: 40px;
        // margin-right: 32px;
        // width: 80px;
        width: 62px;
        margin-right: -8px;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
        // line-height: 36px;
        // margin-right: 38px;
        /*margin-bottom: 10px;*/
      }
      .liItemBox {
        flex: 1;
        font-size: 15px;
        color: #333;
        display: flex;
        flex-wrap: wrap;
        .liItem {
          // cursor: pointer;
          // position: relative;
          // display: inline-block;
          // color: #333333;
          // box-shadow: 0 0 0 1px #636363 inset;
          // font-size: 16px;
          // margin-bottom: 35px;
          // margin-right: 10px;
          // min-width: 130px;
          // max-width: 160px;
          // text-align: center;
          // line-height: 36px;
          // overflow: hidden;
          height: 40px;
          line-height: 40px;
          text-align: center;
          border: 1px solid #999;
          // width: 150px;
          padding: 0 20px;
          margin: 0 10px 10px;
          cursor: pointer;
          &.active {
            border: 2px solid #c6001f !important;
            position: relative;
            color: #c6001f;
            &::after {
              content: '';
              display: inline-block;
              position: absolute;
              right: 0;
              bottom: 0;
              width: 16px;
              height: 16px;
              background: url('../../assets/icons/other/checkConfig.png') center/100% 100%;
            }
            // position: relative;
            // /*border: 2px solid #F50F0F; !*no*!*/
            // // box-shadow: none;
            // background-image: url(../../assets/images/seller/seller.png);
            // background-position: center;
            // background-size: 100% 95%;
            // line-height: 36px;
            // color: #c6001f;
            // &:before {
            //   content: '';
            //   position: absolute;
            //   width: 14px;
            //   height: 14px;
            //   right: 3px;
            //   bottom: 3px;
            //   background-image: url(../../assets/images/seller/seller-detail-active.png);
            //   background-size: contain;
            //   z-index: 1;
            // }
          }
        }
        .liColorItem {
          display: inline-block;
          // border: none;
          .icon {
            width: 60px;
            height: 60px;
            margin-right: 15px;
            &.active {
              position: relative;
              /*border: 2px solid #F50F0F; !*no*!*/
              box-shadow: none;
              background-image: url(../../assets/images/seller/seller.png);
              background-size: 100% 100%;
              line-height: 36px;
              color: #c6001f;
              &:before {
                content: '';
                position: absolute;
                width: 14px;
                height: 14px;
                right: 3px;
                bottom: 3px;
                background-image: url(../../assets/images/seller/seller-detail-active.png);
                background-size: contain;
                z-index: 1;
              }
            }
          }
          .text {
            margin-left: 17px;
            margin-top: 9px;
          }
        }
      }
    }
  }
}
</style>
